import { Fetch } from 'lib';
import type { DiscountCode } from 'types';

type RequestResponses = DiscountCode;

type RequestParameters = {
  id: string;
};

const getDiscountCode = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminDiscountCode/getDiscountCode',
    params,
  });

export { getDiscountCode };
